import { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";

import __ from "web/Layout/Translations";

import { IApiRequestMethods } from "web/api/apiRequestTypes";

import { RestAPIS } from "web/constants/restUrls";

import { request } from "web/api";
import { setNotificationError } from "web/features/app/appSlice";

import ActivityItemMUI, { IActivityItemProps } from "../activityItemMUI";

export interface IBarcodeDownloaderActivityItem extends IActivityItemProps {
  benefitUUID: string;
  generateUrl: string;
}

export const onGeneratePDFHandler = async (
  url: string,
  setLoading: (arg: boolean) => void,
  dispatch: Dispatch
) => {
  const finalPdfGenerationUrl = `${RestAPIS.SUB_MANAGEMENT_API}${url}`;

  try {
    setLoading(true);
    const response = await request(finalPdfGenerationUrl, {
      method: IApiRequestMethods.PUT,
    });

    const { url: pdfUrl } = response as { url: string };

    if (pdfUrl) window.open(pdfUrl);
  } catch (err: any) {
    if (err) {
      const errorMessage = __(
        "Nie można wygenerować dokumentu ponieważ konfiguracja na to nie pozwala. Skontaktuj się ze swoim pracodawcą."
      );
      dispatch(
        setNotificationError({
          message: errorMessage,
          timeout: 5000,
        })
      );
    }
  }

  setLoading(false);
};

const BarcodeDownloaderActivityItemMUI: FC<IBarcodeDownloaderActivityItem> = ({
  description,
  benefitUUID,
  generateUrl,
  name,
  receiverName,
  receiverLastname,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  return (
    <ActivityItemMUI
      key={`${benefitUUID}-email-${generateUrl}`}
      name={name}
      description={description}
      onClick={() => onGeneratePDFHandler(generateUrl, setLoading, dispatch)}
      disabled={loading}
      receiverName={receiverName}
      receiverLastname={receiverLastname}
      loading={loading}
    >
      {__("Pobierz")}
    </ActivityItemMUI>
  );
};

export default BarcodeDownloaderActivityItemMUI;
